import React from 'react';
import './JoinUs.scss';

const JoinUs = () => {
    return (
        <div className=" joinus-body justify-content-center ">
            <div className="main-join-us-container col-md-12 justify-content-center pl-5 pr-5 pt-5 pb-5">
                <div className="container-join-us col-md-10 justify-content-center">
                    <div className="col-md-123 px-4 "><p className=" text-description2  text-white pt-5 pb-5  text-center" data-aos="fade-up">Wanna start your journey with us?</p></div>
                    <div className="col-md-123 px-4 justify-content-center">
                        <div class="quote" data-aos="fade-up">
                            <span class="left">❝</span>
                            <blockquote>
                                Some people are born into wonderful families. Others have to find or create them. Being a member of a family is a priceless membership that we pay nothing for but love.
                            </blockquote>
                            <small>Jim Stovall</small>
                            <span class="right">❞</span>
                        </div>
                        <p className="text-description1 text-white pt-3 pb-0 text-center" data-aos="fade-up">It is with a great pleasure we invite you all to join with our brand new family 'Leo Club of Colombo Monarch', where you will get all the support needed to achieve the impossible. We are a friendly and helpful bunch who work for each other, day in and day out. So this is the ultimate opportunity for all the passionate individuals who look forward to working and growing together and we are confident that you will enjoy being part of a massive family that always strives to be the best. </p>
                        <p className="text-description1 text-white pt-3 pb-3 " data-aos="fade-up">Buckle up your shoes and join with the team who believes "The beginning is always today!!"</p>
                    </div>
                    <div className="container1   pt-5 pb-5 col-md-12 justify-content-center text-center" data-aos="zoom-in-up">
                        {/*  <img src="/assets/images/joinus.jpg" alt="" className="joinus-body" /> */}
                        <a target="_blank" rel="noreferrer" href="https://forms.gle/LVBcbqttTLJ8hkZe8"><button className="btn1"><div className="join-us-text">Join Now</div></button></a>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinUs;
